import Divider from "components/MeForm/Divider";

function InvoiceType({ section, onClick, record }) {
  const shop = record?.shop;
  const available = [];
  if (shop?.pos_authorization) available.push({ kind: "P", label: "POS" });
  if (shop?.electronic_authorization)
    available.push({ kind: "1", label: "Venta Electrónica" });
  if (shop?.manual_authorization)
    available.push({ kind: "M", label: "Venta Manual" });

  const selected = record?.invoice_type?.id ?? record?.invoice_type ?? "";

  function handleClick(value) {
    onClick(section, value);
  }

  if (!shop || available.length === 0) {
    return null;
  }

  return (
    <div className="mt-3" id={`${section}-section`}>
      <Divider text={`sale_call_center.${section}`} key={section} />
      <div className="grid grid-cols-1 md:grid-cols-3 tablet:grid tablet:grid-cols-3 gap-5 mb-4">
        {available.map((t) => (
          <div
            className={`text-center cursor-pointer shadow-sm py-8 rounded-md hover:opacity-50 ${
              selected === t.kind ? "bg-blue-300" : "bg-blue-100"
            }`}
            key={t.kind}
            onClick={() => handleClick(t.kind)}
          >
            <p className="pointer-events-none">{t.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
export default InvoiceType;
